/* Buy straight from the article, 25 Oct 2026.
   Every garment figure in an article body ([data-vfp="figure"] with a /products/ link) gets a
   slim "Buy this shirt" line under its caption. Tapping it opens the size buttons (colour already
   set from the photo, with a small "change colour"), the "What size am I?" finder for its blank
   and an Add to cart that opens Dawn's cart notification, so the reader never leaves the article.
   Every box starts closed as a single line ("Choose your colour", or "Choose your size" when
   there is only one colour), so the story does not turn into a catalogue and every
   blog_buy_open is a reader's own tap (Joel, 26 Oct 2026). No product links are added here, so
   blog_product_click positions stay comparable. GA4: blog_buy_open, blog_add_to_cart. */
(function () {
  var body = document.querySelector('.article-template__content');
  if (!body) return;
  var GARMENT = /shirt|tee|hoodie|sweat|tank|kids|top/i;
  var money = function (cents) { return '€' + (cents / 100).toFixed(2); };   // matches the captions
  var article = (window.VFP_ARTICLE || '').toString();
  var track = function (name, params) {
    try { if (typeof gtag === 'function') gtag('event', name, Object.assign({ article_handle: article }, params)); } catch (e) {}
  };
  var esc = function (s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); };
  var css = document.createElement('style');
  css.textContent =
    '.vfp-buy{margin:6px auto 0;max-width:620px;text-align:center;font-size:1.35rem;line-height:1.4}' +
    '.vfp-buy__toggle{font:inherit;font-size:1.45rem;font-weight:700;background:rgb(13,23,51);color:#fff;border:1.5px solid rgb(13,23,51);border-radius:999px;padding:9px 20px;cursor:pointer;box-shadow:3px 3px 0 rgb(255,212,0);margin-top:4px}' +
    '.vfp-buy__toggle:hover{transform:translate(-1px,-1px);box-shadow:4px 4px 0 rgb(255,212,0)}' +
    '.vfp-buy[data-open] .vfp-buy__toggle{background:rgb(var(--color-background));color:rgb(13,23,51)}' +
    '.vfp-buy__img-fade{transition:opacity .18s}' +
    '.vfp-buy__toggle span{display:inline-block;transition:transform .2s}' +
    '.vfp-buy[data-open] .vfp-buy__toggle span{transform:rotate(180deg)}' +
    '.vfp-buy__panel{display:none;text-align:left;margin:10px 0 0;padding:12px 14px;border:1px solid rgba(var(--color-foreground),.12);border-radius:10px}' +
    '.vfp-buy[data-open] .vfp-buy__panel{display:block}' +
    '.vfp-buy__colour{margin:0 0 8px;font-size:1.3rem}' +
    '.vfp-buy__colour button{font:inherit;font-size:1.25rem;background:none;border:0;padding:0;margin-left:6px;cursor:pointer;text-decoration:underline;color:inherit;opacity:.75}' +
    '.vfp-buy__row{display:flex;flex-wrap:wrap;gap:6px;margin:0 0 10px}' +
    '.vfp-buy__opt{font:inherit;font-size:1.3rem;padding:6px 11px;border:1px solid rgba(var(--color-foreground),.3);border-radius:999px;background:rgb(var(--color-background));color:rgb(var(--color-foreground));cursor:pointer;min-height:34px}' +
    '.vfp-buy__opt[aria-pressed="true"]{border-color:rgb(var(--color-foreground));box-shadow:inset 0 0 0 1px rgb(var(--color-foreground));font-weight:600}' +
    '.vfp-buy__dot{position:relative;width:34px;height:34px;padding:0;border-radius:50%;border:1px solid rgba(var(--color-foreground),.3);background:transparent;cursor:pointer;flex:0 0 34px}' +
    '.vfp-buy__dot[aria-pressed="true"]{border:2px solid rgb(var(--color-foreground))}' +
    '.vfp-buy__dot span{position:absolute;inset:3.5px;border-radius:50%;box-shadow:inset 0 0 0 1px rgba(0,0,0,.08)}' +
    '.vfp-buy__opt:disabled{opacity:.35;text-decoration:line-through;cursor:not-allowed}' +
    '.vfp-buy__add{display:block;width:100%;font:inherit;font-size:1.4rem;font-weight:600;padding:10px 14px;border:1px solid rgb(var(--color-foreground));border-radius:8px;background:rgb(var(--color-foreground));color:rgb(var(--color-background));cursor:pointer}' +
    '.vfp-buy__add:disabled{background:none;color:rgb(var(--color-foreground));opacity:.55;cursor:not-allowed}' +
    '.vfp-buy__msg{margin:6px 0 0;font-size:1.25rem}' +
    '.vfp-buy__msg:empty{display:none}' +
    '.vfp-buy .vfp-sf{margin-top:10px;padding-top:10px;border-top:1px solid rgba(var(--color-foreground),.1)}' +
    '.vfp-buy .vfp-sf__ask{display:flex;flex-wrap:wrap;align-items:center;gap:6px 10px}' +
    '.vfp-buy .vfp-sf__q{font-weight:600;font-size:1.25rem}' +
    '.vfp-buy .vfp-sf__row{display:inline-flex}' +
    '.vfp-buy .vfp-sf__row input{width:7rem;font:inherit;font-size:1.35rem;padding:4px 8px;border:1px solid rgba(var(--color-foreground),.3);border-right:0;border-radius:6px 0 0 6px}' +
    '.vfp-buy .vfp-sf__u{font:inherit;font-size:1.2rem;padding:0 9px;border:1px solid rgba(var(--color-foreground),.3);border-radius:0 6px 6px 0;background:rgba(var(--color-foreground),.05);color:inherit;cursor:pointer}' +
    '.vfp-buy .vfp-sf__hint{margin:4px 0 0;font-size:1.15rem;opacity:.65}' +
    '.vfp-buy .vfp-sf__answer{margin:4px 0 0}' +
    '.vfp-buy .vfp-sf__answer:empty{display:none}' +
    '.vfp-buy .vfp-sf__more{margin-top:4px;font:inherit;font-size:1.2rem;background:none;border:0;padding:0;cursor:pointer;text-decoration:underline;color:inherit;opacity:.8}';
  document.head.appendChild(css);

  var figures = Array.prototype.filter.call(body.querySelectorAll('[data-vfp="figure"]'), function (f) {
    return f.querySelector('a[href*="/products/"]') && !f.querySelector('.vfp-buy');
  });
  var seen = {};

  figures.forEach(function (fig) {
    var href = fig.querySelector('a[href*="/products/"]').getAttribute('href');
    var handle = href.split('/products/')[1].split(/[?#/]/)[0];
    if (!handle || seen[handle]) return;   // one picker per product per article
    seen[handle] = 1;
    fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p || !GARMENT.test(p.type || '') || !p.available) return;
      var ci = p.options.findIndex(function (o) { return /colou?r/i.test(o.name || o); });
      var si = p.options.findIndex(function (o) { return /size/i.test(o.name || o); });
      if (si < 0) return;
      var colours = ci >= 0 ? (p.options[ci].values || []) : [];
      var sizes = p.options[si].values || [];
      var type = (p.type || '').toLowerCase();
      var alt = ((fig.querySelector('img') || {}).alt || '').toLowerCase();
      var pick = { c: colours.find(function (c) { return alt.indexOf(c.toLowerCase()) > -1; }) || colours[0], s: null, showColours: colours.length > 1 };
      var variantFor = function (c, s) {
        return p.variants.find(function (v) { return (ci < 0 || v.options[ci] === c) && v.options[si] === s; });
      };
      // swap the figure photo for the picked colour's own cast shot (its variant image)
      var img = fig.querySelector('img');
      var original = img ? { src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), alt: img.getAttribute('alt') } : null;
      var showColour = function (c) {
        if (!img) return;
        var v = p.variants.find(function (x) { return (ci < 0 || x.options[ci] === c) && x.featured_image; });
        var startColour = colours.find(function (k) { return (original.alt || '').toLowerCase().indexOf(k.toLowerCase()) > -1; });
        var src = (c === startColour || !v) ? original.src : v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=1200';
        if (img.getAttribute('src') === src) return;
        img.classList.add('vfp-buy__img-fade'); img.style.opacity = '.35';
        var pre = new Image(); pre.onload = function () {
          img.removeAttribute('srcset'); img.setAttribute('src', src);
          if (c !== startColour && v && v.featured_image.alt) img.setAttribute('alt', v.featured_image.alt);
          else if (original.alt) img.setAttribute('alt', original.alt);
          img.style.opacity = '1';
        };
        pre.onerror = function () { img.style.opacity = '1'; };
        pre.src = src;
        track('blog_colour_swap', { product_handle: handle, colour: c });
      };
      var box = document.createElement('div'); box.className = 'vfp-buy';
      // "Choose your colour" when there is one to choose: tapping swaps the photo, so the first tap
      // already does something visible (Joel, 26 Oct 2026). Single-colour garments ask for a size.
      var label = colours.length > 1 ? 'Choose your colour' : 'Choose your size';
      box.innerHTML = '<button type="button" class="vfp-buy__toggle" aria-expanded="false">' + label + ' <span aria-hidden="true">▾</span></button><div class="vfp-buy__panel"></div>';
      var panel = box.querySelector('.vfp-buy__panel');
      var toggle = box.querySelector('.vfp-buy__toggle');
      var setOpen = function (on, user) {
        if (on) box.setAttribute('data-open', ''); else box.removeAttribute('data-open');
        toggle.setAttribute('aria-expanded', String(on));
        if (on && user) track('blog_buy_open', { product_handle: handle });
      };
      toggle.addEventListener('click', function () { setOpen(!box.hasAttribute('data-open'), true); });
      var draw = function () {
        var v = pick.s ? variantFor(pick.c, pick.s) : null;
        var html = '';
        if (colours.length) {
          html += '<p class="vfp-buy__colour">Colour: <strong>' + esc(pick.c) + '</strong>' +
            (colours.length > 1 && !pick.showColours ? '<button type="button" data-more>change colour</button>' : '') + '</p>';
          if (pick.showColours) {
            html += '<div class="vfp-buy__row" role="group" aria-label="Colour">' + colours.map(function (c) {
              var hex = (window.VFP_HEX || {})[c] || '#c8c8c8';   // same dots as the product page
              return '<button type="button" class="vfp-buy__dot" data-c="' + esc(c) + '" aria-pressed="' + (c === pick.c) + '" title="' + esc(c) + '" aria-label="' + esc(c) + '"><span style="background:' + esc(hex) + '"></span></button>';
            }).join('') + '</div>';
          }
        }
        html += '<div class="vfp-buy__row" role="group" aria-label="Size">' + sizes.map(function (s) {
          var sv = variantFor(pick.c, s);
          return '<button type="button" class="vfp-buy__opt" data-s="' + esc(s) + '" aria-pressed="' + (s === pick.s) + '"' + (sv && sv.available ? '' : ' disabled') + '>' + esc(s) + '</button>';
        }).join('') + '</div>';
        html += '<button type="button" class="vfp-buy__add"' + (v && v.available ? '' : ' disabled') + '>' +
          (v ? 'Add to cart · ' + money(v.price) : 'Pick a size') + '</button><p class="vfp-buy__msg" aria-live="polite"></p>';
        panel.innerHTML = html;
        if (box._finder) panel.appendChild(box._finder);
        var more = panel.querySelector('[data-more]');
        if (more) more.addEventListener('click', function () { pick.showColours = true; draw(); });
        panel.querySelectorAll('[data-c]').forEach(function (b) { b.addEventListener('click', function () {
          pick.c = b.getAttribute('data-c');
          var sv = pick.s && variantFor(pick.c, pick.s); if (!sv || !sv.available) pick.s = null;
          showColour(pick.c);
          draw();
        }); });
        panel.querySelectorAll('[data-s]').forEach(function (b) { b.addEventListener('click', function () { pick.s = b.getAttribute('data-s'); draw(); }); });
        panel.querySelector('.vfp-buy__add').addEventListener('click', function () { add(v, this); });
      };
      var add = function (v, btn) {
        if (!v) return;
        btn.disabled = true; var msg = panel.querySelector('.vfp-buy__msg'); msg.textContent = '';
        var cn = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var payload = { items: [{ id: v.id, quantity: 1 }] };
        if (cn && cn.getSectionsToRender) {
          payload.sections = cn.getSectionsToRender().map(function (s) { return s.id; });
          payload.sections_url = window.location.pathname;
        }
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            btn.disabled = false;
            if (!res.ok) { msg.textContent = res.j.description || 'That did not go into the cart. Please try again.'; return; }
            var item = (res.j.items && res.j.items[0]) || res.j;
            track('blog_add_to_cart', { product_handle: handle, variant_title: v.title, value: v.price / 100, currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
            if (cn && cn.renderContents && res.j.sections) cn.renderContents({ key: item.key, sections: res.j.sections });
            else msg.textContent = 'Added to your cart.';
          })
          .catch(function () { btn.disabled = false; msg.textContent = 'That did not go into the cart. Please try again.'; });
      };
      // size finder for the product's blank, read from a tiny alternate product template
      fetch('/products/' + handle + '?view=vfpblank').then(function (r) { return r.ok ? r.text() : ''; }).then(function (b) {
        b = (b || '').trim();
        if (/^\d+$/.test(b) && window.VFP_SIZES && window.VFP_SIZES[b] && customElements.get('vfp-sizefinder')) {
          var f = document.createElement('vfp-sizefinder'); f.className = 'vfp-sf';
          f.dataset.blank = b; f.dataset.sizes = sizes.join('|');
          f.dataset.unit = (window.Shopify && Shopify.country === 'US') ? 'in' : 'cm';
          f.dataset.href = '/products/' + handle;
          box._finder = f; panel.appendChild(f);
        }
      }).catch(function () {});
      var cap = fig.querySelector('figcaption');
      if (cap) cap.insertAdjacentElement('afterend', box); else fig.appendChild(box);
      draw();
    }).catch(function () {});
  });
})();
